/* soldout-alt: every sold-out size's cross-link is visible from page load (CSS).
   This only marks whichever one matches the currently selected size. */
(function () {
  function sync() {
    document.querySelectorAll('[data-soldout-alt]').forEach(function (box) {
      var field = box.previousElementSibling;
      if (!field) return;
      var checked = field.querySelector('input[type="radio"]:checked');
      var val = checked ? checked.value : null;
      box.querySelectorAll('.soldout-alt__link').forEach(function (a) {
        a.classList.toggle('is-selected', val !== null && a.dataset.soldoutAltFor === val);
      });
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('input[type="radio"]')) sync();
  });
  document.addEventListener('DOMContentLoaded', sync);
  if (document.readyState !== 'loading') sync();
  new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });
})();
